module.exports = __webpack_public_path__ + "img/29fc0bd.png";